import "@/css/share/_reset.scss";
import "@/css/share/_base.scss";
import "@/css/share/_share.scss";
import "@/css/share/components/_loading.scss";
import "@/css/share/components/_header.scss";
import "@/css/share/components/_footer.scss";

// === 非關鍵：延遲載入（prefetch 或 idle 後載入）===
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/fontawesome.min.css");
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/regular.min.css");


